<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-shop"></i> 采购商列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="search-row">
          <div class="search-item">
            <span class="search-label">采购商名称</span>
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入采购商名称"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">联系人</span>
            <el-input 
              v-model="searchForm.cont_name" 
              placeholder="请输入联系人"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">联系电话</span>
            <el-input 
              v-model="searchForm.mobile" 
              placeholder="请输入联系电话"
              clearable
              size="small"
              class="search-input"
            ></el-input>
          </div>
          <div class="search-actions">
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search" size="small">搜索</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh-right" size="small">重置</el-button>
            <el-button type="success" @click="addData" icon="el-icon-plus" size="small">新增采购商</el-button>
          </div>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card" @click="filterStatus('all')">
          <div class="stat-icon total"><i class="el-icon-s-shop"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">采购商总数</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('active')">
          <div class="stat-icon active"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ activeCount }}</div>
            <div class="stat-label">已启用</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus('inactive')">
          <div class="stat-icon inactive"><i class="el-icon-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ inactiveCount }}</div>
            <div class="stat-label">已禁用</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon domestic"><i class="el-icon-location"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ domesticCount }}</div>
            <div class="stat-label">境内采购商</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
          
          <el-table-column label="采购商信息" min-width="220">
            <template slot-scope="scope">
              <div class="purchaser-info">
                <div class="purchaser-name">
                  <i class="el-icon-s-shop"></i>
                  <span>{{ scope.row.name }}</span>
                </div>
                <div class="purchaser-sn">
                  <span class="label">国家：</span>
                  <span class="value">{{ scope.row.nation || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="联系人" width="150" align="center">
            <template slot-scope="scope">
              <div class="contact-info">
                <div class="contact-name">
                  <i class="el-icon-user"></i>
                  <span>{{ scope.row.cont_name || '-' }}</span>
                </div>
                <div class="contact-phone">
                  <i class="el-icon-phone"></i>
                  <span>{{ scope.row.telephone || '-' }}</span>
                </div>
                <div class="contact-phone">
                 
                  <span>{{ scope.row.passport || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="经营类型" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.location_type == 1 ? 'success' : 'primary'" size="small" effect="plain">
                {{ scope.row.location_type == 1 ? '境内采购' : '境外采购' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="所在地区" min-width="180">
            <template slot-scope="scope">
              <div class="address-info">
                <i class="el-icon-location"></i>
                <span>{{ scope.row.province || '' }} {{ scope.row.city || '' }} {{ scope.row.district || '' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-switch
                :value="scope.row.status === 1"
                disabled
                active-color="#00b578"
                inactive-color="#ff4d4f"
              ></el-switch>
            </template>
          </el-table-column>
          
          <el-table-column label="入驻时间" width="160" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.join_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="view-btn" @click="goInfo(scope.row)">
                <i class="el-icon-view"></i> 查看
              </el-button>
              <el-button type="text" size="small" class="edit-btn" @click="goEdit(scope.row)">
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button type="text" size="small" class="delete-btn" @click="handleDel(scope.row)">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 批量操作栏 -->
      <div class="batch-actions" v-if="multipleSelection.length > 0">
        <span class="batch-info">已选择 {{ multipleSelection.length }} 项</span>
        <el-button type="danger" size="small" @click="batchDelete" :loading="batchDeleting">
          <i class="el-icon-delete"></i> 批量删除
        </el-button>
        <el-button type="success" size="small" @click="batchEnable">
          <i class="el-icon-check"></i> 批量启用
        </el-button>
        <el-button type="warning" size="small" @click="batchDisable">
          <i class="el-icon-close"></i> 批量禁用
        </el-button>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-s-shop"></i>
        <p>暂无采购商数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "purchaserList",
  data() {
    return {
      loading: false,
      batchDeleting: false,
      
      // 搜索表单
      searchForm: {
        name: "",
        cont_name: "",
        mobile: ""
      },
      
      // 统计数据
      activeCount: 0,
      inactiveCount: 0,
      domesticCount: 0,
      
      // 表格数据
      tableLoadData: [],
      multipleSelection: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() {
      return { cursor: 'pointer' }
    },
    
    // 计算统计数据
    calculateStats() {
      if (!this.tableLoadData.length) {
        this.activeCount = 0
        this.inactiveCount = 0
        this.domesticCount = 0
        return
      }
      this.activeCount = this.tableLoadData.filter(item => item.status === 1).length
      this.inactiveCount = this.tableLoadData.filter(item => item.status === 0).length
      this.domesticCount = this.tableLoadData.filter(item => item.location_type == 1).length
    },
    
    // 筛选
    filterStatus(type) {
      if (type === 'active') this.searchForm.status = 1
      else if (type === 'inactive') this.searchForm.status = 0
      else delete this.searchForm.status
      this.searchSubmit()
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    resetSearch() {
      this.searchForm = { name: "", cont_name: "", mobile: "" }
      delete this.searchForm.status
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchForm
      }
      
      this.$axios.findPurchaserListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    addData() {
      this.$router.push('/shopForeignForm')
    },
    
    goInfo(row) {
      this.$router.push({ path: '/shopForeignInfo', query: { id: row.id } })
    },
    
    goEdit(row) {
      this.$router.push({ path: '/shopForeignForm', query: { id: row.id } })
    },
    
    handleDel(row) {
      this.$confirm(`确定要删除采购商"${row.name}"吗？删除后无法恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          id: row.id,
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        }
        this.$axios.purchaserDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.DataList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    batchDelete() {
      this.$confirm(`确定要删除选中的 ${this.multipleSelection.length} 个采购商吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.batchDeleting = true
        const ids = this.multipleSelection.map(item => item.id).join(',')
        const param = {
          ids: ids,
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        }
        this.$axios.purchaserBatchDel(param).then(res => {
          this.batchDeleting = false
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.DataList()
            this.$refs.multipleTable.clearSelection()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    
    batchEnable() {
      this.batchUpdateStatus(1, '启用')
    },
    
    batchDisable() {
      this.batchUpdateStatus(0, '禁用')
    },
    
    batchUpdateStatus(status, action) {
      const ids = this.multipleSelection.map(item => item.id).join(',')
      const param = {
        ids: ids,
        status: status,
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      }
      this.$axios.purchaserBatchStatus(param).then(res => {
        if (res.code == 200) {
          this.$message.success(`成功${action} ${this.multipleSelection.length} 个采购商`)
          this.DataList()
          this.$refs.multipleTable.clearSelection()
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .search-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }
  
  .search-item {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .search-label {
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
      min-width: 80px;
      text-align: right;
    }
    
    .search-input { width: 180px; }
    .search-input ::v-deep .el-input__inner { border-radius: 20px; }
  }
  
  .search-actions {
    display: flex;
    gap: 10px;
    margin-left: auto;
    
    .el-button { border-radius: 20px; padding: 8px 18px; }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; border-color: #1acd8c; } }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 140px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease; cursor: pointer;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.active { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.inactive { background: linear-gradient(135deg, #e6a23c, #ebb563); }
      &.domestic { background: linear-gradient(135deg, #ef705a, #ff8c6f); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.purchaser-info {
  .purchaser-name { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; i { font-size: 16px; color: #1677ff; } span { font-weight: 500; } }
  .purchaser-sn { .label { font-size: 12px; color: #8c8f98; } .value { font-size: 12px; color: #1677ff; font-family: monospace; } }
}

.contact-info {
  .contact-name { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #e6a23c; font-size: 12px; } span { font-size: 13px; } }
  .contact-phone { display: flex; align-items: center; gap: 6px; i { color: #00b578; } span { font-size: 12px; color: #8c8f98; } }
}

.address-info { display: flex; align-items: center; gap: 6px; justify-content: center; i { color: #909399; } span { font-size: 12px; color: #606266; } }
.time-text { font-size: 12px; color: #8c8f98; }

.view-btn { color: #909399; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #a6a9ad; } }
.edit-btn { color: #1677ff; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #4096ff; } }
.delete-btn { color: #ff4d4f; i { margin-right: 4px; } &:hover { color: #ff7875; } }

.batch-actions {
  display: flex; align-items: center; gap: 16px; padding: 12px 16px; background: #f0f7ff; border-radius: 12px; margin-bottom: 20px;
  .batch-info { font-size: 13px; color: #1677ff; flex: 1; }
  .el-button { border-radius: 20px; }
}

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

@media (max-width: 1200px) {
  .search-bar .search-item .search-input { width: 150px; }
  .search-bar .search-item .search-label { min-width: 70px; }
}
</style>